import type { FormEventHandler } from 'react';

import { useTranslation } from 'react-i18next';

import SearchIcon from '@crm/shared/assets/icons/search.svg?react';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '@crm/shared/ui';

import type { UseFormRegisterReturn } from 'react-hook-form';

interface DealsSearchFormProps {
    inputProps: UseFormRegisterReturn<'query'>;
    onSubmit: FormEventHandler<HTMLFormElement>;
}

export const DealsSearchForm = ({ inputProps, onSubmit }: DealsSearchFormProps) => {
    const { t } = useTranslation();

    return (
        <form className="w-full max-w-xs" onSubmit={onSubmit}>
            <InputGroup className="h-9">
                <InputGroupInput
                    {...inputProps}
                    maxLength={255}
                    placeholder={t('crm.common.dealsSearch.placeholder')}
                />
                <InputGroupAddon align="inline-end" className="h-9 border-l p-0 has-[>button]:mr-0">
                    <InputGroupButton
                        type="submit"
                        variant="ghost"
                        size="icon-sm"
                        className="h-9 rounded-l-none"
                        title={t('crm.common.dealsSearch.submitTitle')}
                    >
                        <SearchIcon />
                    </InputGroupButton>
                </InputGroupAddon>
            </InputGroup>
        </form>
    );
};
